export default function Home({ onHandleRoute }) {
    return (
        <div className="App">
            <div className="main-block-bg"></div>
            <div className="main-block">
                <div className="main-caption">
                    <div className="plus">+</div>
                    <div className="main-text">
                        <span className="points">1000</span>
                        <span className="text-karma">В КАРМУ</span>
                    </div>
                </div>
                <div className="additional-text">
                    Завершите год в&nbsp;плюсе!
                    <br />
                    Поддержите людей с&nbsp;БАС&nbsp;&mdash;
                    в&nbsp;благодарность фонд &laquo;Живи сейчас&raquo; дарит
                    плюсы <br /> в&nbsp;карму вам или тому, кого
                    вы&nbsp;выберете получателем.
                </div>
                <div className="main-caption">
                    <button
                        className="ref-link"
                        onClick={() => onHandleRoute('self')}
                    >
                        <img
                            className="pack"
                            src={process.env.PUBLIC_URL + 'pack.png'}
                        />
                        <span className="ref-text">СЕБЕ</span>
                    </button>
                    <button
                        className="ref-link"
                        onClick={() => onHandleRoute('friend')}
                    >
                        <img
                            className="pack"
                            src={process.env.PUBLIC_URL + 'pack.png'}
                        />
                        <span className="ref-text">ДРУГУ</span>
                    </button>
                </div>
                <div className="main-caption">
                    <p className="footer-text">
                        &laquo;Живи сейчас&raquo;&nbsp;&mdash; единственный
                        в&nbsp;России фонд, который оказывает помощь людям
                        с&nbsp;боковым амиотрофическим склерозом, редкой
                        неизлечимой болезнью (она была у физика Стивена
                        Хокинга). Делая пожертвование, вы помогаете людям
                        с&nbsp;БАС улучшить качество жизни: своевременно
                        получить консультации специалистов, жизненно необходимое
                        оборудование, социальную и психологическую помощь.
                    </p>
                </div>
                <div className="main-caption">
                    <p className="footer-text">
                        Мы&nbsp;хотим, чтобы в&nbsp;Новый год наша открытка
                        с&nbsp;необычным посланием согревала вас или того, кому
                        вы&nbsp;захотите ее подарить.
                    </p>
                </div>
            </div>
        </div>
    )
}
